/*
 * Public API Surface of ipamodule
 */

// components
export * from './lib/dashboard/dashboard'

// route
//export * from './lib/dashboard.routes'
// config
export * from './dashboard-config'